import { Toaster as ShadcnToaster } from "@/components/ui/toaster";

export function Toaster() {
  return <ShadcnToaster />;
}
